const SENSITIVE_TOKEN_PATHS = [
  /^\/auth\/new-password\/?$/,
  /^\/bezplatna-konsultacja\/[^/]+\/odwolaj\/?$/
]

export function isSensitiveTelemetryPath(pathname: string): boolean {
  return SENSITIVE_TOKEN_PATHS.some(pattern => pattern.test(pathname))
}
